import { render, staticRenderFns } from "./interfaceDlg.vue?vue&type=template&id=283b82cc&scoped=true&"
import script from "./interfaceDlg.vue?vue&type=script&lang=js&"
export * from "./interfaceDlg.vue?vue&type=script&lang=js&"
import style0 from "./interfaceDlg.vue?vue&type=style&index=0&id=283b82cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b82cc",
  null
  
)

export default component.exports